import React from 'react';
import Aux from '../../hoc/Aux';
import { useTranslation } from 'react-i18next';
import { URLS } from '../../urls';

const wizardProductSystemImageCard = (props) => {

  const { t } = useTranslation();
  const hasUpdates = props.hasUpdates || false;
  const seals = props.seals || [];

  // Buttonhöhe auf z.b iphone6 und einer bestimmten Anzahl von Buttons verringern
  // damit der Weiter-Button noch zu sehen ist

  const features = () => {
    let filtered = ["einfache_nachbelegung",
    "ueberbelegung_gt_60",
    "unregelmaessige_bauteiloeffnung",
    "einseitige_montage",
    "feuchtraum_geeignet",
    "geschuetzter_aussenbereich",
    "schalldaemmend",
    "faserfrei",
    "oib1",
    "oib2"].filter(function(e){ return props.featureList.includes(e) });

    return filtered.map( (feature, index) => <li key={feature}>{t('product_system_feature.' + feature )}</li> );
  }

  const sealsList = (seals) => {
    return seals.sort( (a,b) => parseInt(a.position) - parseInt(b.position)).map( (s, index) => <img key={s.id} style={{height: "35px"}} alt='' src={URLS['BACKEND'] + '/' + s.image_url} /> );
  }

  return (
    <Aux>
      <div className="col-auto mb-3">
        <div className="card h-100 product-system-card" style={{width: "20rem"}} onClick={ (e) => props.onClick(props.value) }>
          <div className="product-system-image-container">
            <img onClick={ (e) => props.onClick(props.value) } alt={props.imageName} className="card-img-top" src={URLS['BACKEND'] + '/' + props.imageUrl} />
            { (hasUpdates === true)?
            <div className="product-system-icon-container">
              <i className="material-icons">update</i>
            </div> : null }
          </div>
          <div className="card-body" style={{fontSize: "0.95rem", border: "0px", backgroundColor: "white", paddingBottom: "0.5rem", paddingTop: "0.5rem"}}>
            <h5 className="card-title" style={{fontSize: "0.95rem", marginBottom: "0.5rem", marginTop: "0.5rem"}}>{props.title}</h5>
            <ul className="product_system_features">
              { features() }
            </ul>
            { (seals.length > 0)?
            <div className="seal-container">
              { sealsList(seals) }
            </div> : null }
          </div>
          <div className="card-footer" style={{padding: "5px", borderTop: "0px", backgroundColor: "white"}}></div>
        </div>
      </div>
    </Aux>
  );

};

export default wizardProductSystemImageCard;



// WEBPACK FOOTER //
// ./src/components/Wizard/WizardProductSystemImageCard.js